import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'LABEL_UPDATE',
    smsDelete : 'LABEL_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        label: [],

        submitSuccess: false,
        labelLoading: false,
        labelError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_LABEL(state, label) {
            state.label = label;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        LABEL_LOADING (state, loading) {
            state.labelLoading = loading;
        },

        LABEL_ERROR (state, hasError) {
            state.labelError = hasError;
        }
    },

    actions: {
        async addLabel ({commit, dispatch}, payload) {
            commit('LABEL_LOADING', true);
            commit('LABEL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_label, payload.label, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchLabel')
                return response

            } catch (e) {
                commit('LABEL_ERROR', true);
            } finally {
                commit('LABEL_LOADING', false);
            }
        },

        async fetchLabel ({ commit }) {
            commit('LABEL_LOADING', true);
            commit('LABEL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.label_list, config);
                let response = result.data
                commit('SET_LABEL', response.data);

            } catch(error) {
                commit('LABEL_ERROR', true);
            } finally {
                commit('LABEL_LOADING', false);
            }
        },

        async updateLabel ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_label + payload.id, payload.label, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchLabel')
                return response

            } catch (e) {
                commit('LABEL_ERROR', true);
            } finally {
                commit('LABEL_LOADING', false);
            }
        },
        
        async deleteLabel({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.label_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchLabel')
            return response
        }
    },

    getters: {}
}
